export default __webpack_public_path__ + "static/media/cert-student-hkgcsmeaa.38742f7d.jpg";